var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"email-preview","height":"auto","width":"800"}},[_c('modal-title',{staticClass:"m-4"},[_vm._v(" Email Preview ")]),_c('div',{staticClass:"email-preview-content",domProps:{"innerHTML":_vm._s(_vm.emailHtml)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }